module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/aq664-1187526318bad40281ee2ade3fa2d88a.jpg";